import { CloudUpload } from "lucide-react";
import useStep1 from "./useStep1"
import { Button } from "@/components/ui";
import { FormSectionHeader, Loader } from "@/components";
import { StepsProps } from "../types";

const Step1 = ({onNextStepClick, onBackClick}: StepsProps) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isUploadPending,
    file,
    onValidate
  } = useStep1({onNextStepClick});
  
  return (
    <div className="bg-white p-4 rounded-md my-4">
      <div className="mb-6">
        <FormSectionHeader className="text-[18px]" wrapperClassName="mb-0">Upload Files</FormSectionHeader>
        <span className="text-[12px] text-gray-400">Select and upload the files here</span>
      </div>
      <div {...getRootProps()} className="lg:col-span-6 border-2 border-dashed rounded-md px-3 py-8 flex flex-col items-center justify-center gap-3 cursor-pointer">
        <input {...getInputProps()} />
        <div className="p-3 bg-blue-50 rounded-full">
          <CloudUpload className="stroke-primary h-8 w-8" />
        </div>
        <span className="text-[16px] font-semibold">
          {
            file ? 
              <div className="text-black flex flex-col gap-1 items-center">
                <span className="text-[14px]">{file?.name || ""}</span>
                <div className="text-[10px] text-gray-600 flex flex-row gap-1 items-center">
                  {file?.size ? `${(file?.size / (1024 * 1024)).toFixed(2)} MB` : ""} 
                  <div className="h-[3px] w-[3px] bg-gray-500 rounded-full" /> 
                  <span>Uploaded just now</span>
                </div>
              </div> : isDragActive ? <p>Drop the files here ...</p> :
              <p>Drop file here or browse</p>
          }
        </span>
        <span className="text-[12px] text-slate-500 w-[300px] text-center">Accepts .xlsx or.csv up to 5 MB</span>
        <Button variant="outline"> Browse File </Button>
      </div>
      <div className="my-4 flex flex-row items-center justify-end gap-4">
        <Button variant="outline" disabled={isUploadPending} onClick={onBackClick}>Cancel</Button>
        <Button disabled={isUploadPending} onClick={onValidate}>
          {isUploadPending ? <Loader variant="secondary" /> : <></>}
          Validate File
        </Button>
      </div>
    </div>
  )
}

export default Step1;